module.exports = __webpack_public_path__ + "img/emirates_logo.4190f3bf.png";